<template lang="pug">
  .password-text-field
    icon(name="password" class="icon-input-type")

    input(
      name="password"
      :type="textType"
      :value="value"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :required="required"
      @input="$emit('input', $event.target.value)"
    )

    f7-link(class="visible-password" @click="$emit('click', $event)")
      icon-visible-password(:color="visibleColor")
</template>

<style lang="scss" scoped>
.password-text-field {
  background-color: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
}

.icon-input-type {
  position: absolute;
  margin-left: 17px;
}

input {
  height: 56px;
  width: 100%;
  @extend %input-text;
  text-indent: 52px;

  @include placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
}

.visible-password {
  margin: 0 16px 0 8px;
}
</style>

<script>
import IconVisiblePassword from '@/components/atoms/IconVisiblePassword'

export default {
  components: {
    IconVisiblePassword,
  },
  props: {
    value: { type: String },
    type: { type: String, default: 'text' },
    name: { type: String, required: true },
    placeholder: { type: String },
    secure: { type: Boolean, default: false },
    autocomplete: { type: String, default: 'off' },
    required: { type: Boolean, default: true },
  },
  computed: {
    textType() {
      return this.secure ? 'password' : this.type
    },
    visibleColor() {
      return this.secure ? 'rgba(255, 255, 255, 0.4)' : '#fff'
    },
  },
}
</script>
